<template>
    <v-container fluid class="px-0 py-0">
        <p class="sys-info">先点击左边的账号，再选择右边的权限，分配完成之后，点击确认保存。</p>
        <v-layout v-if="cfg" row nowrap>
            <v-flex sm4 style="border-right: 1px solid #eee;">
                <ul v-if="cfg.accs && cfg.accs.length >0" class="users">
                    <li v-for="(a, idx) in cfg.accs" :key="a.id" :class="{'actived': a.actived}"
                        @click="onSelectAcc(idx)">
                        {{a.name}}
                    </li>
                </ul>
            </v-flex>
            <v-flex sm8>
                <ul v-if="actived" class="roles">
                    <li v-for="r in cfg.roles" :key="r.id">
                        <v-checkbox :label="r.name" v-model="actived.roles[r.id]" />
                    </li>
                </ul>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
export default {
    name: "admin-module-role-setting",
    props: {
        cfg: Object
    },
    data() {
        return {
            actived: null
        };
    },
    watch: {
        cfg() {
            this.init();
        }
    },
    methods: {
        init() {
            if (self.cfg && self.cfg.accs) {
                self.cfg.accs.push({ name: 'xxx' });
            }
        },
        onSelectAcc(idx) {
            let self = this, cfg = self.cfg, acc = cfg.accs[idx];
            self.actived = null;
            for (let i in cfg.accs) {
                let a = cfg.accs[i];
                if (a.actived && i != idx) {
                    a.actived = false;
                    self.$set(cfg.accs, i, a);
                }
            }

            acc.actived = !acc.actived;

            if (acc.actived) {
                if (!acc.roles) {
                    acc.roles = {};
                    for (let r of cfg.roles) {
                        acc.roles[r.id] = false;
                    }
                }
                self.actived = acc;
            }
            self.$set(cfg.accs, idx, acc);
        }
    },
    created() {
        this.init();
    }
}
</script>
<style scoped>
.users {
    list-style: none;
}

.users li {
    cursor: pointer;
    line-height: 30px;
    font-size: 16px;
    padding: 8px;
    margin: 8px 0;
    border-bottom: 1px solid #eee;
}

.users li .v-icon {
    padding-right: 8px;
}

.users li:hover,
.users li.actived {
    color: #0068B7;
}

.roles {
    list-style: none;
}
</style>

